(() => {
  const openClass = 'dd-filter-drawer-open';
  let previousFocus = null;

  function getDrawer() {
    return document.querySelector('[data-dd-filter-drawer]');
  }

  function setDrawerState(isOpen) {
    const drawer = getDrawer();
    if (!drawer) return;

    document.body.classList.toggle(openClass, isOpen);
    drawer.classList.toggle('is-open', isOpen);
    drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

    if (isOpen) {
      previousFocus = document.activeElement;
      window.setTimeout(() => {
        drawer.querySelector('[data-dd-filter-close]')?.focus();
      }, 120);
      return;
    }

    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus();
    }
  }

  function updateViewButtonCount() {
    const productCount = document.getElementById('ProductCount');
    if (!productCount) return;

    const count = productCount.dataset.productCount || productCount.textContent.match(/\d+/)?.[0] || '';
    const desktopCount = document.getElementById('ProductCountDesktop');

    document.querySelectorAll('[data-dd-filter-view-count]').forEach((element) => {
      element.textContent = count;
    });

    if (desktopCount) {
      desktopCount.innerHTML = productCount.innerHTML;
      desktopCount.dataset.productCount = productCount.dataset.productCount || '';
      desktopCount.dataset.totalCount = productCount.dataset.totalCount || '';
    }
  }

  function initProductGridObserver() {
    const container = document.getElementById('ProductGridContainer');
    if (!container || container.dataset.ddFilterGridObserved === 'true') return;

    container.dataset.ddFilterGridObserved = 'true';

    const observer = new MutationObserver(() => {
      if (typeof window.initDDProductCardSliders === 'function') {
        window.initDDProductCardSliders(container);
      }
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-dd-filter-open]')) {
      event.preventDefault();
      setDrawerState(true);
      return;
    }

    if (event.target.closest('[data-dd-filter-close]')) {
      event.preventDefault();
      setDrawerState(false);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && document.body.classList.contains(openClass)) {
      setDrawerState(false);
    }
  });

  const countObserver = new MutationObserver(updateViewButtonCount);

  function initDDCollectionFilters() {
    const productCount = document.getElementById('ProductCount');
    if (productCount && productCount.dataset.ddFilterCountObserved !== 'true') {
      productCount.dataset.ddFilterCountObserved = 'true';
      countObserver.observe(productCount, { childList: true, subtree: true, attributes: true });
    }

    updateViewButtonCount();
    initProductGridObserver();
  }

  initDDCollectionFilters();

  document.addEventListener('shopify:section:load', initDDCollectionFilters);
})();
